export default from './Logo';



// WEBPACK FOOTER //
// ./src/containers/Logo/index.js